








































































import { Vue, Component } from 'vue-property-decorator';
import { RouteConfig } from 'vue-router';
import { SHOW_SNACKBAR } from '../../common/constants';
import { Industries } from '../../common/enum';
import Brand from '../../common/model/Brand';
import {
  ADMIN_BRAND_ASSETS, ADMIN_BROADCAST_CENTER, ADMIN_DASHBOARD, ADMIN_PRODUCT_INFORMATION, ADMIN_ROUTES, ADMIN_USERS_PAGE, ADMIN_VIDEO_VAULT,
} from '../../common/routes.config';
import { eventBus } from '../../main';
import adminModule from '../../store/modules/admin.module';
import brandModule from '../../store/modules/brand.module';
import AdminAddSubbrand from './AdminAddSubbrand.vue';
import superadminModule from '../../store/modules/superadmin.module';

@Component({
  components: {
    AdminAddSubbrand,
  },
})
export default class AdminNavbar extends Vue {
  tab = 0;

  settingButtons = [{ title: 'Logout', event: this.logout }];

  get isUserSuperAdmin(): boolean {
    return !!superadminModule.superadmin;
  }

  get routes(): Array<RouteConfig> {
    if (!brandModule.brand) { return ADMIN_ROUTES; }
    if (brandModule.brand.industry === Industries.Liquor) {
      return [ADMIN_BRAND_ASSETS, ADMIN_PRODUCT_INFORMATION, ADMIN_VIDEO_VAULT, ADMIN_BROADCAST_CENTER, ADMIN_USERS_PAGE, ADMIN_DASHBOARD];
    }
    return ADMIN_ROUTES;
  }

  get primaryColor(): string {
    // If brand is not set, make the primaryColor the chrncl brand color.
    if (!brandModule.brand || !brandModule.brand.primary_color) {
      return '#293645';
    }
    return brandModule.brand.primary_color;
  }

  get brandName(): string {
    if (!brandModule.brand) {
      return '';
    }
    return brandModule.brand.name;
  }

  get brandFontColor(): string {
    return '#FFFFFF';
  }

  get brand(): Brand | undefined {
    if (!brandModule.brand) { return; }
    return brandModule.brand;
  }

  get subBrands(): Array<Brand> {
    return brandModule.subBrands.sort((a, b) => {
      const textA = a.name.toUpperCase();
      const textB = b.name.toUpperCase();
      if (textA < textB) { return -1; }
      if (textA > textB) { return 1; }
      return 0;
    });
  }

  created(): void {
    for (let routeIndex = 0; routeIndex < ADMIN_ROUTES.length; routeIndex += 1) {
      if (this.$router.currentRoute === ADMIN_ROUTES[routeIndex]) {
        this.tab = routeIndex;
      }
    }
  }

  selectedTabChanged(): void {
    this.$router.push(this.routes[this.tab]);
    this.$emit('tabChanged', this.tab);
  }

  async logout(): Promise<void> {
    eventBus.$emit(SHOW_SNACKBAR, 'Logging out.');
    await adminModule.logout();
  }

  async selectedBrandChanged(brandId: string): Promise<void> {
    await brandModule.fetchBrand(brandId);
  }

  buttonClicked(button: any): void {
    button.event();
  }
}
